import gql from "graphql-tag";

export const CANCEL_SUBSCRIPTION = gql`
  mutation ($reason: String) {
    cancelSubscription(reason: $reason) {
      id
    }
  }
`;
